var map = {
	"./com-logo.svg": 4403,
	"./down-icon.svg": 4412,
	"./error-icon.svg": 7674,
	"./item-down-icon.svg": 8526,
	"./item-up-icon.svg": 8907,
	"./next-to-right-icon.svg": 1070,
	"./nfc-card-logo.svg": 3096,
	"./pay-icon.svg": 6778,
	"./pay-succses-icon.svg": 5180,
	"./question-icon.svg": 3412,
	"./r-icon.svg": 1382,
	"./search-icon.svg": 1748,
	"./select-icon.svg": 2284,
	"./up-icon.svg": 3365,
	"./wang-icon.svg": 6275
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 2922;